import * as React from "react"

function SvgSalad(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20.59 8.47c-.89.21-2.44.53-4.01.65 1.07 1.72 1.08 3.59 1.08 3.66 0 0-3.03-.95-5.08-2.47-.32 2.03-1.69 3.97-1.69 3.97S9.08 12.19 8.51 9.8c-.05-.24-.09-.48-.1-.69-1.75.51-3.93.7-5.08.77-.38.86-.8 2.2-.8 3.04 0 12.03 20 12.14 20 .12 0-1.62-.75-3.27-1.94-4.57zM10.2 2c.86 1.44.71 3.23.67 3.55"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M21.34 8.29s-3.51-5.02-10.53-2.73C5.26 3.45 2.53 9.92 2.53 9.92s3.37-.09 5.88-.82c.01.22.05.45.1.69.56 2.39 2.38 4.48 2.38 4.48s1.37-1.94 1.69-3.97c2.05 1.52 5.08 2.47 5.08 2.47s.02-1.91-1.07-3.66c2.39-.18 4.75-.82 4.75-.82z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SvgSalad
